<template>
    <div>
        <Modal v-model="moveFromShow" width="450" :mask-closable="false" @on-cancel="onMoveCancel">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>选择云端文件夹</span>
            </p>
            <div>
                <TreeSelecter ref="treeSelecter" @destination-folder="onTagSelect" />
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="moveCannel">取消</Button>
                <Button type="primary" size="large" @click="moveOk">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import treeselecter from './droptree_child.vue'
export default {
    name: 'FolderTree',
    data() {
        return {
            moveFromShow: false,
            selectNode: [],
            typeOfUpload: 0, //1=一键上传,2=选择上传
        }
    },
    components: {
        'TreeSelecter': treeselecter,
    },
    methods: {
        bindFolderTree(data, type) {
            console.log('bindFolderTree=====>')
            this.moveFromShow = true
            this.typeOfUpload = type
            this.$refs.treeSelecter.show(data)
        },
        moveOk() {
            //提交
            //console.log(this.$refs.treeFolderSelector.value)
            if (this.selectNode.value) {
                var folderid = this.selectNode.value
                console.log('emit folderid=>' + folderid)
                this.$emit('onFolderSelected', folderid, this.typeOfUpload, this.selectNode)
                this.selectNode = []
                //关闭
                this.moveFromShow = false
            } else {
                //this.$emit('onSelectCannel')
                this.$Message.warning('您没有选择文件夹')
                this.selectNode = []
            }

        },
        moveCannel() {
            this.moveFromShow = false
            this.$emit('onSelectCannel')
        },
        onMoveCancel() {
            this.moveFromShow = false
            this.$emit('onSelectCannel')
        },
        onTagSelect(node) {
            console.log('onFolderTreeSelect==>')
            console.log(node)
            this.selectNode = node
            // this.$refs.treeFolderSelector.alwaysOpen = false
        },
        clearText() {
            this.selectNode = undefined
        },
    }
}
</script>